import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {Subject} from 'rxjs';
import {SharedImports} from '@shared/shared-imports';
import {StepperModule} from 'primeng/stepper';
import {takeUntil} from 'rxjs/operators';
import {OrganizationService} from '@services/organizations.service';
import {PrefillRegistrationModel, RegistrationGetRatesModel, RegistrationRatesModel, SelfRegistrationModel} from '@app/models/user-registration.model';
import {RegistrationPage2BillingComponent} from '@app/public/rapid-registration/registration-page-2-billing/registration-page-2-billing.component';
import {RapidRegistrationPage1InfoComponent} from '@app/public/rapid-registration/rapid-registration-page-1-info/rapid-registration-page-1-info.component';
import {RegistrationPage3AddressComponent} from '@app/public/rapid-registration/registration-page-3-address/registration-page-3-address.component';
import {RegistrationPage4ConfirmComponent} from '@app/public/rapid-registration/registration-page-4-confirm/registration-page-4-confirm.component';
import {ConfirmationService} from 'primeng/api';
import {PaymentMethodModel} from '@app/models/payment-methods.model';

@Component({
  templateUrl: './rapid-registration.component.html',
  styleUrls: ['./rapid-registration.component.scss'],
  imports: [SharedImports, StepperModule, RegistrationPage2BillingComponent, RapidRegistrationPage1InfoComponent, RegistrationPage3AddressComponent, RegistrationPage4ConfirmComponent]
})
export class PublicRapidRegistrationCustomComponent implements OnInit, OnDestroy {
  logo: string;
  tenant: string;
  jwt: string;
  active: number | undefined = 1;
  organizationId: string;
  orgGuid: string;
  personPrefill: PrefillRegistrationModel;
  dataLoaded: boolean = false;
  stepOneComplete: boolean = false;
  stepTwoComplete: boolean = false;
  stepThreeComplete: boolean = false;
  stepFourComplete: boolean = false;
  tenantAllowsRegistrationPayment: boolean = false;
  registrationProfile = {} as SelfRegistrationModel;
  registrationPrefillRates: RegistrationRatesModel[];
  personPrefillRates = {
    FirstName: null,
    LastName: null,
    EmailAddress: null,
    Address1: null,
    Address2: null,
    City: null,
    StateProvinceID: null,
    Zip: null,
    ZipPlus4: null,
    CountryID: null,
    MobilePhone: null,
    PersonProfileTypeID: null,
    PersonProfileStatusID: null,
    PersonProfileClassificationID: null,
    PersonProfileDuesGroupID: null,
    EmployerOrganizationID: null,
    OccupationID: null,
    ContractID: null,
  } as RegistrationGetRatesModel;
  // orgCampaignDetails = {} as SOICampaignModel;
  private ngUnsubscribe = new Subject();

  constructor(private route: ActivatedRoute, private organizationService: OrganizationService,
              private confirmationService: ConfirmationService) {
  }

  ngOnInit() {
    this.route.queryParams.pipe(takeUntil(this.ngUnsubscribe)).subscribe({
      next: (params) => {
        // get the query parameters
        if (params && params.jwt) {
          sessionStorage.setItem('registrationToken', params.jwt);
          this.getPrefillData();
        } else {
          sessionStorage.setItem('registrationToken', null);
        }

        if (params && params.org) {
          this.orgGuid = params.org;
        }
      }
    });
  }

  getPrefillData() {
    this.organizationService.getPersonOrganizationRegistrationPrefillData()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe({
        next: (res) => {
          this.personPrefill = res;
          this.tenantAllowsRegistrationPayment = this.personPrefill.ChargeDues;
        }, error: (e) => {
          console.log(e);
          if (e.error.Message === 'Token Expired') {
            const ref = this.confirmationService.confirm({
              header: 'Warning',
              icon: 'fas fa-triangle-exclamation',
              rejectVisible: false,
              acceptVisible: false,
              message: `Your link has expired. You can <a href="/public/email-verification/registration/${this.orgGuid}">request a new link</a> to restart the process.`,
              accept: () => {

              },
            });
          }
          if (e.error.Message === 'Registration Already Complete') {
            const ref = this.confirmationService.confirm({
              header: 'Warning',
              icon: 'fas fa-triangle-exclamation',
              rejectVisible: false,
              acceptVisible: false,
              message: 'Your link has expired because an account has already been completed with this email address',
              reject: () => {
                window.location.replace('/login');
              },
            });
          }
          this.dataLoaded = true;
          console.debug(e);
        }
      });
  }

  updatePrefillData() {
    if (this.personPrefill.PaymentMethod === null && this.personPrefill.ChargeDues) {
      this.personPrefill.PaymentMethod = {} as PaymentMethodModel;
    }

    Object.entries(this.personPrefill).forEach(([key, value]) => {
      if (key in this.personPrefillRates) {
        this.personPrefillRates[key] = value;
      }
    });

    this.organizationService.updatePersonOrganizationRegistrationPrefillData(this.personPrefillRates)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe({
        next: (res) => {
          this.registrationPrefillRates = res;
        }, error: (e) => {
          console.log(e);
          this.dataLoaded = true;
          console.debug(e);
        }
      });
  }

  updatePrefillPaymentData() {
    this.organizationService.updatePersonOrganizationRegistrationPrefillPaymentData(this.personPrefill.PaymentMethod)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe({
        next: (res) => {

        }, error: (e) => {
          console.log(e);
          this.dataLoaded = true;
          console.debug(e);
        }
      });
  }


  ngOnDestroy(): void {
    this.ngUnsubscribe.next(true);
    this.ngUnsubscribe.complete();
  }
}
